export default __webpack_public_path__ + "static/media/scan_code.32efe83e.svg";